import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../Store";
import { NavbarBrand } from "../components/NavbarBrand";
import { NavbarNav } from "./components/NavbarNav";
import { DropdownCuentaIndividual } from "./components/DropdownCuentaIndividual";
import { SkeletonHeaderIndividual } from "./components/SkeletonHeaderIndividual";

import useIsMobile from "../../../js/utilities/useIsMobile";
import { useTranslations } from "../../../hooks/use-translations";
import { useIndividualHeaderDropdown } from "../../../hooks/header/useIndividualHeaderDropdown";
import { useLanguage } from "../../../hooks/use-language";
import { useId } from "../../../hooks/use-id";
import { HeaderActions } from "../components/header-actions";
import { HeaderLangButton } from "../components/languaje-button/HeaderLangButton";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * Componente del header individual
 * @returns {JSX.Element} - GeneralHeader
 */
export const IndividualHeader = () => {
  const lang = useLanguage();
  const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

  const globalState = useContext(store);
  const { state } = globalState;

  const [isLoading, setIsLoading] = useState(true);

  const isMobile = useIsMobile();

  const showADropdown = useIndividualHeaderDropdown();
  const dropdownButtonRef = useRef(null);
  const menuId = useId("user-menu");

  useEffect(() => {
    if (dropdownButtonRef.current) {
      globalState.dispatch({
        type: "CHANGE",
        path: "individualHeaderDropdown.triggerButtonRef",
        value: dropdownButtonRef,
      });
    }
  }, [dropdownButtonRef.current]);

  useEffect(() => {
    if (state?.datosHeader) {
      setIsLoading(false);

    }
  }, [state?.datosHeader]);

  const toggleUserDropdown = () => {
    showADropdown.setVisible(
      !showADropdown?.state?.visible
    );
  };
  return (
    <>
      {isLoading ?
        <SkeletonHeaderIndividual />
        :
        <div className="general-header">
          <nav className="h-100 row mx-0">
            <div className="col-6 col-lg-2 col-xl-4 px-0 d-flex">
              <NavbarBrand />
            </div>

            {!isMobile &&
              <div className="col-lg-10 col-xl-8">
                <NavbarNav textosInterfaz={textosInterfaz} />
              </div>
            }

            {isMobile &&
              <ul className="header-general-controls ml-auto">
                {/* Idioma */}
                <li>
                  <HeaderLangButton />
                </li>
                {/* Menú de usuario */}
                <li>
                  <button
                    ref={dropdownButtonRef}
                    type="button"
                    onClick={toggleUserDropdown}
                    className="focusable-red icon-button icon-responsive"
                    aria-expanded={
                      showADropdown?.state?.visible
                    }
                    aria-controls={menuId}
                    aria-label={
                      textosInterfaz
                        ?.general_header_buttons_account ||
                      "Abrir menú de usuario"
                    }
                  >
                    <Icon
                      icon="material-symbols:menu-rounded"
                      width={40}
                    />
                  </button>
                </li>
              </ul>
            }
          </nav>

          {isMobile &&
            <DropdownCuentaIndividual textosInterfaz={textosInterfaz} />
          }

          {/* Acciones desktop */}
          {!isMobile && (
            <HeaderActions
              textosInterfaz={textosInterfaz}
              background="dark"
            />
          )}
        </div>
      }
    </>
  )
}